<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form :model="form">
      <el-form-item label="活动标题：">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="举办城市：">
        <el-input v-model="form.city"></el-input>
      </el-form-item>
      <el-form-item label="报名人数：">
        <el-input v-model="form.limit" type="number"></el-input>
      </el-form-item>
      <el-form-item label="报名头图" label-width="150px">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="rankHeadSuccess"
          :on-remove="headRemove"
        >
          <el-button size="small" type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.head" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog(false)">取 消</el-button>
      <el-button type="primary" @click="setRank">{{ this.form.id ? '更 新' : '新 增' }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "edit_rank",
  props: ["info"],
  data() {
    return {
      dialogFormVisible: true,
      deleteInvoiceDialog: false,
      agreementName: null,
      form: {
        id: null,
        type: "rank",
        title: null,
        city: null,
        limit: null,
        status: 1,
        startTime: new Date().getTime(),
        expireTime: new Date().getTime(),
        head: ""
      },
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signature: "",
        host: "",
        success_action_status: 200,
        callback: ""
      }
    };
  },
  created() {
    this.getOssSign();
  },
  mounted() {
    this.form.id = !this.info ? null : this.info.id;
    this.form.title = !this.info ? null : this.info.title;
    this.form.city = !this.info ? null : this.info.city;
    this.form.limit = !this.info ? null : this.info.limit;
    this.form.head = !this.info ? null : this.info.head;
  },
  methods: {
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    rankHeadSuccess(res) {
      if (res.statusCode === 200) {
        this.form.head = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    headRemove() {
      this.form.header = null;
    },
    async setRank() {
      let form = this.form;
      if (this.form.id) {
        let res = await this.$http.updateRank(form);
        if (res.data.statusCode === 200) {
          this.closeDialog(true);
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      } else {
        let res = await this.$http.setRank(form);
        if (res.data.statusCode === 200) {
          this.closeDialog(true);
        } else {
          this.$message({
            type: "error",
            message: res.data.message
          });
        }
      }
    },
    closeDialog(type) {
      this.$emit("closeDialog", type);
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/backend/rank/edit_rank.vue